import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { alignHeightsCard } from '../../TariffCard/helpers';
import { connect } from 'react-redux';
import Carousel from '@ertelecom/ui-react/components/carousel';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';
import { formattingVideoForCard } from '~/src/helpers/formatter';
import TariffCardNew from '../../TariffCardNew';
import Option from '../../TariffCardNew/Option';
import { Wrapper, ArrowWrapper, Counter, Dots, DotWrapper, LeftArrow, RightArrow, Slide, SliderWrapper, PaddingWrapper, ActionText, HiddenBlock, PopupTitle, PopupSupTitle, ArchiveListItem, ArchiveList, ArchiveListTitle, ArchiveLine } from './styled';
import Menu from './Menu';
import LotCard from './DeviceCard/LotCard';
import { getDeviceLots, getVideoTariffs } from '~/src/api/videocontrol';
import { day } from '~/src/helpers/declOfNumCallection';
import EmptyPopupCallback from '~/src/components/Popups/EmptyPopup';

const POPUP_ARRAY = {
    move: [
        { day: 7, price: '250 руб.', option: 'archive7' },
        { day: 14, price: '350 руб.', option: 'archive14' },
        { day: 30, price: '450 руб.', option: 'archive30' },
    ],
    full: [
        { day: 7, price: '300 руб.', option: 'archive7' },
        { day: 14, price: '500 руб.', option: 'archive14' },
        { day: 30, price: '800 руб.', option: 'archive30' },
    ],
};

const TariffList = ({ cityDomain, textButtonForCard, bgColor }) => {
    const [state, setState] = useState({
        activeSlide: 0,
        windowWidth: 1990,
        cardType: 'tariffs',
        tariffs: getVideoTariffs(),
        lots: getDeviceLots(),
    });
    const [showModal, setShowModal] = useState(false);

    const onTypeHandler = typeCard => {
        setState({
            ...state,
            cardType: typeCard
        });
    };

    const onClickButtonHandlerForCard = useCallback(() => {
        window.fbq('track', 'lead_body');
        window._tmr.push({ id: '3213734', type: 'reachGoal', goal: 'lead_body' });
        window.location =  '#request';
    }, []);

    useEffect(() => {
        alignHeightsCard();
        setState({
            ...state,
            list: React.createRef(),
        });

        if (process.browser) {
            const alignAfterLoad = () => {
                alignHeightsCard();
                window.addEventListener('resize', () => {
                    setState({
                        ...state,
                        windowWidth: window.innerWidth,
                    });
                });
                window.removeEventListener('load', alignAfterLoad);
            };
            window.addEventListener('load', alignAfterLoad);
        }
    }, []);

    const { cardType, lots, tariffs } = state;

    const CustomCounter = (props) => {
        const { active, count, onClick, slidesToShow } = props;
        const dots = [];
        for (let i = 0; i <= count; i++) {
            dots.push(<Dots key={i} active={i === active} onClick={() => onClick(i)}/>);
        }
        return (
            <Wrapper>
                <DotWrapper>
                    {dots}
                </DotWrapper>
                <Counter>
                    {`Показано
                    ${1 + active === 2 ? 'co' : 'c'}
                    ${1 + active} по
                    ${(slidesToShow) + active} тариф из ${tariffs.length}`
                    }
                </Counter>
            </Wrapper>
        );
    };

    const CustomArrows = (props) => {
        const { swipeLeft, swipeRight } = props;
        return (
            <ArrowWrapper>
                <LeftArrow key='left' type='secondary' onClick={swipeLeft}/>
                <RightArrow key='right' type='secondary' onClick={swipeRight}/>
            </ArrowWrapper>
        );
    };

    const settings = {
        breakpoints: [
            { width: 0, slidesToShow: 1 },
            { width: 765, slidesToShow: 2 },
            { width: 1024, slidesToShow: 3 },
        ]
    };

    const openModalHandler = useCallback(() => setShowModal(true), []);
    const closeModalHandler = useCallback(() => setShowModal(false), []);

    const tariffList = tariffs.map(tariffItem => {
        const tariff = formattingVideoForCard(tariffItem);

        return (
            <Slide key={tariffItem.id}>
                <TariffCardNew
                    key={tariffItem.id}
                    tariff={tariff}
                    cityDomain={cityDomain}
                    onClickButtonHandler={onClickButtonHandlerForCard}
                    hideDescription={false}
                    hideAdditionalProducts={false}
                    textButton={textButtonForCard}
                    additionalProductsTitle='Видеокамеры'
                >
                    {
                        Option({
                            typeOptions: 'quality',
                            title: 'Качество изображения',
                            valueText: 'Full HD',
                            headingColor: tariff.headingColor,
                        })
                    }
                    {
                        Option({
                            typeOptions: 'cloud',
                            title: 'Хранение видеозаписи',
                            value: tariffItem.archiveDays,
                            valueText: day(tariffItem.archiveDays),
                            headingColor: tariff.headingColor,
                            typeValue: tariff.archiveOption ? 'quantityChannels' : '',
                            onClickValue: openModalHandler,
                        })
                    }
                </TariffCardNew>
            </Slide>
        );
    });

    const devices = lots.map((lot, index) =>
            <Slide key={index}>
                <LotCard
                    domain={cityDomain}
                    key={index}
                    description={lot.body}
                    name={lot.name}
                    price={lot.price}
                    button_text={lot.button_text}
                    image={lot.image}
                    type={lot.type.id}
                    promoPrice={lot.price_action}
                    data={lot.props}
                    onClickButtonHandlerForCard={onClickButtonHandlerForCard}
                />
            </Slide>);

    const cardTariffs = (cardType === 'tariffs') ? tariffList : devices;
    const activeMenuItem = (cardType === 'tariffs') ? 0 : 1;

    const menuItems = [
        { route: 'tariffs', text: 'Тарифы' },
        { route: 'devices', text: 'Оборудование' }
    ];

    return (
        <PaddingWrapper bgColor={bgColor} nonTopPadding id='tariffs'>
            <GridContainer>
                <Menu items={menuItems} activeItem={activeMenuItem} typeHandler={onTypeHandler} />
                <SliderWrapper>
                    <Carousel visibleCardWidth={1024}
                              responsive={settings.breakpoints}
                              showDots={true}
                              dots={CustomCounter}
                              arrows={CustomArrows}>
                        {cardTariffs}
                    </Carousel>
                </SliderWrapper>
                <HiddenBlock>{devices}</HiddenBlock>
                <ActionText>
                    * Услуга «Видеоконтроль» для клиентов-физических лиц при наличии доступа к сети интернет, который обеспечивается клиентом. Абонентская плата 1 руб./мес. на 6 мес. по рекламной акции «Домашняя камера 250 на 6 мес.» для новых клиентов при подключении услуги «Видеоконтроль» по тарифному плану «Домашняя камера - 250» и приобретении оборудования в период с 01.02.2021 по 31.08.2021. По истечении 6 мес. абонентская плата составит 250 руб./мес. Услуги обработки, хранения данных до 7 дней входят в стоимость услуги. Приложение «Умный Дом.ru» для управления услугой доступно на мобильных устройствах с операционной системой iOS/Android. Стоимость оборудования и подключение оплачиваются отдельно. Full HD (Full High Definition) – от англ. разрешение высокой четкости. Wi-Fi – технология беспроводного доступа.
                </ActionText>
                <EmptyPopupCallback isOpen={showModal} onClose={closeModalHandler}>
                    <PopupTitle>Дополнительные опции в тарифе</PopupTitle>
                    <PopupSupTitle>* Минимальный срок активации опции 1 месяц. Активация опции производится на 1 камеру.</PopupSupTitle>
                    <ArchiveList>
                        <ArchiveListItem>
                            <ArchiveListTitle>Запись по движению</ArchiveListTitle>
                            { POPUP_ARRAY.move.map(item => Option({
                                typeOptions: item.option,
                                title: `${item.day} дней хранения событий`,
                                valueText: item.price,
                                headingColor: '#FF5C5C',
                            }))}
                        </ArchiveListItem>
                        <ArchiveLine />
                        <ArchiveListItem>
                            <ArchiveListTitle>Постоянная запись</ArchiveListTitle>
                            { POPUP_ARRAY.full.map(item => Option({
                                typeOptions: item.option,
                                title: `${item.day} дней хранения полной записи`,
                                valueText: item.price,
                                headingColor: '#FF5C5C',
                            }))}
                        </ArchiveListItem>
                    </ArchiveList>
                </EmptyPopupCallback>
            </GridContainer>
        </PaddingWrapper>
    );
};

TariffList.propTypes = {
    tariffs: PropTypes.array,
    cityDomain: PropTypes.string,
    onClickButtonHandlerForCard: PropTypes.func,
    textButtonForCard: PropTypes.string
};

const mapStateToProps = state => ({
    cityDomain: state.city.currentCity.domain
});

export default connect(
    mapStateToProps,
)(TariffList);
